const path = "/web/login";
export default {
  login: `${path}/login`,
  resetsenha: `${path}/recuperador-senha`,
  mudarSenha: `${path}/update-senha`,
  logOff: `${path}/logout`,
  alteraremail: `${path}/alteracao-email`,
  usuarioBuscar: (cpf) => `${path}/get-usuario/${cpf}`,
  usuarioAlterar: `${path}/update-usuario`,
  usuarioAlterarSenha: `${path}/update-usuario-senha`,
};
